import React, { memo } from 'react';

import Tooltip from '../Tooltip';
import NavBarSuperior from '../NavBarSuperior/NavBarSuperior';

import LaneNewCoursesInProgress from './LaneNewCoursesInProgress';

import FooterHome from '../Home/FooterHome';
import SubFooter from '../Home/SubFooter';

const Cursos = () => {
  return (
    <>
      <Tooltip id="home" />
      <NavBarSuperior home courses reviewSmartBar />
      <LaneNewCoursesInProgress />
      <FooterHome />
      <SubFooter />
    </>
  );
};

export default memo(Cursos);
